// extracted by mini-css-extract-plugin
export default {"themeBtn":"ThemeToggle_themeBtn__bccYj","hidden":"ThemeToggle_hidden__O0TWq","spin":"ThemeToggle_spin__xFqww"};